import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Profile from '@/components/Profile'
import Home from '@/components/Home'
import Register from '@/components/Register'
import Welcome from '@/components/welcome/Index'
import SampleCalendar from '@/components/_sample/Calendar'
import SchemeDetail from '@/components/plant/programme/SchemeDetail.vue'
import Scheme from '@/components/plant/programme/Index.vue'
import Geo from '@/components/_util/Geo.vue'

import meta from './meta.js'
import plant from './plant.js'
import resource from './resource.js'
import product from './product.js'
import monitor from './monitor.js'
import report from './report.js'
import setting from './setting.js'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [{
      path: '/util/geo',
      component: Geo
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/profile',
      component: Profile
    },
    {
      path: '/register',
      component: Register
    },
    {
      path: '/sample',
      component: SampleCalendar
    },
    {
      path: '/',
      component: Home,
      redirect: 'welcome',
      children: [{
          path: 'welcome',
          component: Welcome
        },
        /**
         * 基础信息
         */
        meta,
        /**
         * 生产资料管理
         */
        resource,
        plant,
        /**
         * 生产过程
         */
        product,
        /**
         * 监测预警
         */
        monitor,
        /**
         * 生产报表
         */
        report,
        /**
         * 系统设置
         */
        setting
      ]
    },
    {
      path: '/ceshi/:id',
      component:SchemeDetail
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js